import React, { useState, useEffect } from "react";
import Swal from "sweetalert";

import { getCaracteristicasArticulo } from "../repository";

const FUNCION_LABEL = "Función y beneficios del producto";

const ProductSpecifications = (props) => {
  const [caracteristicas, setCaracteristicas] = useState([]);
  const [funcionBeneficios, setFuncionBeneficios] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const codigo = props.codigo;

  useEffect(() => {
    buscaCaracteristicas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buscaCaracteristicas = () => {
    getCaracteristicasArticulo(codigo)
      .then((response) => {
        if (response.status === "success") {
          const all = response.result || [];
          const funcion = all.find(
            (i) =>
              (i.Caracteristica || "").trim().toLowerCase() ===
              FUNCION_LABEL.toLowerCase()
          );
          const specs = all.filter(
            (i) =>
              (i.Caracteristica || "").trim().toLowerCase() !==
              FUNCION_LABEL.toLowerCase()
          );
          setCaracteristicas(specs);
          setFuncionBeneficios(funcion ? funcion.Valor : null);
          setIsLoading(false);
        } else if (
          (response.message || "")
            .toLowerCase()
            .startsWith("no se encontró información")
        ) {
          setCaracteristicas([]);
          setFuncionBeneficios(null);
          setIsLoading(false);
        } else {
          setCaracteristicas([]);
          setFuncionBeneficios(null);
          setIsLoading(false);
          Swal(
            "Error obtener la información [Especificaciones]",
            response.message,
            "error"
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        Swal("Error obtener la información [Especificaciones]", err, "error");
      });
  };

  return (
    <div
      className="modal fade"
      id={"modalSpecs" + codigo}
      data-backdrop="static"
      data-keyboard="false"
      tabIndex="-1"
      aria-labelledby={"modalSpecs" + codigo + "Label"}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title text-center"
              id={"modalSpecs" + codigo + "Label"}
            >
              <span className="badge badge-warning ml-1 mr-1">
                {caracteristicas.length}
              </span>
              <small>
                {caracteristicas.length === 1
                  ? "Especificación"
                  : "Especificaciones"}
                &nbsp;de:&nbsp;
              </small>
              <span className="badge badge-secondary ml-1 mr-1">{codigo}</span>
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.closeModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row bg-warning">
                <div className="col mt-2">
                  <h6>Característica</h6>
                </div>
                <div className="col mt-2">
                  <h6>Valor</h6>
                </div>
              </div>
              {isLoading ? (
                <div className="text-center">
                  <p>Cargando...</p>
                  <div
                    className="spinner-border text-warning"
                    role="status"
                    aria-hidden="true"
                  ></div>
                </div>
              ) : caracteristicas.length === 0 && !funcionBeneficios ? (
                <div className="text-center py-5">
                  <p className="mb-1">
                    <strong>Sin especificaciones técnicas</strong>
                  </p>
                  <p className="mb-0 text-muted">
                    <small>
                      Este producto aún no tiene una ficha técnica disponible.
                    </small>
                  </p>
                </div>
              ) : (
                <>
                  {caracteristicas.map((item, index) => (
                    <div
                      className="row bg-light border-bottom"
                      key={index + codigo + item.Caracteristica}
                    >
                      <div className="col border-right">
                        <small>{item.Caracteristica}</small>
                      </div>
                      <div className="col">
                        <small>{item.Valor}</small>
                      </div>
                    </div>
                  ))}
                  {funcionBeneficios && (
                    <div className="mt-3 p-3 bg-light border rounded">
                      <p className="mb-1">
                        <strong>
                          <small>{FUNCION_LABEL}</small>
                        </strong>
                      </p>
                      <p className="mb-0">
                        <small>{funcionBeneficios}</small>
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={props.closeModal}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSpecifications;
